import { useContext, useMemo } from "react";
import { AppContext } from "../../root/Root";
import { CreativeReviewContext } from "../../../contexts/contexts";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import { CreativeReview } from "../../../components/common/creativeReview/CreativeReview";
import { PoolMetadata } from "../../../components/bis/poolMetadata/PoolMetadata";
import { useValidVisual } from "../../../hooks/bis/useValidVisual";
import useMappingKeyStatus from "../../../hooks/common/useMappingKeyStatus";
import useReviewCreative from "../../../hooks/bis/useReviewCreative";
import { DATA_SOURCE } from "../../../constants";
import "../../../style/common.scss";

const metadataComponent = (props) => <PoolMetadata {...props} isReview />;

export const Level3 = () => {
  useContext(AppContext);

  const useReviewCreativeOutput = useReviewCreative();

  const contextValue = useMemo(
    () => ({
      metadataComponent,
      useValidVisual,
      useMappingKeyStatus,
    }),
    [],
  );

  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid xs={12}>
          <CreativeReviewContext.Provider value={contextValue}>
            <CreativeReview
              dataSource={DATA_SOURCE.bis}
              useReviewCreativeOutput={useReviewCreativeOutput}
            />
          </CreativeReviewContext.Provider>
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
